export default "__VITE_ASSET__26a9238c__"